import { METHOD } from "./method";

export const API_EMPLOYEE_PRODUCTIVITY = {
    LIST_PERIOD: {
        api: '/v1/hr-adm/hr-metrics/productivity/periods/list',
        method: METHOD.POST
    },
    EXPORT_PERIOD: {
        api: '/v1/hr-adm/hr-metrics/productivity/periods/list/export',
        method: METHOD.POST
    },
    CREATE_PERIOD: {
        api: '/v1/hr-adm/hr-metrics/productivity/periods',
        method: METHOD.POST
    },
    DELETE_PERIOD: {
        api: '/v1/hr-adm/hr-metrics/productivity/periods',
        method: METHOD.DELETE
    },

    EXPORT_EMPLOYEE: {
        api: '/v1/hr-adm/hr-metrics/productivity/list/export',
        method: METHOD.POST
    },
    DETAIL: {
        api: '/v1/hr-adm/hr-metrics/productivity/list',
        method: METHOD.POST
    },
    UPDATE: {
        api: '/v1/hr-adm/hr-metrics/productivity',
        method: METHOD.PUT
    },
    DELETE: {
        api: '/v1/hr-adm/hr-metrics/productivity',
        method: METHOD.DELETE
    },
    SUBMIT: {
        api: '/v1/hr-adm/hr-metrics/productivity/submit',
        method: METHOD.POST
    },

    DOWNLOAD_TEMPLATE: {
        api: '/v1/hr-adm/hr-metrics/productivity/import/download-template',
        method: METHOD.POST
    },
    FILE_VALIDATION: {
        api: '/v1/hr-adm/hr-metrics/productivity/import/validate',
        method: METHOD.POST
    },
    IMPORT: {
        api: '/v1/hr-adm/hr-metrics/productivity/import/process',
        method: METHOD.POST
    },

    LIST_JOB_TITLE: {
        api: '/v1/hr-adm/hr-metrics/productivity/job-titles',
        method: METHOD.GET
    },
    LIST_DEPARTMENT: {
        api: '/v1/hr-adm/hr-metrics/productivity/departments',
        method: METHOD.GET
    },
    LIST_DIVISION: {
        api: '/v1/hr-adm/hr-metrics/productivity/divisions/list',
        method: METHOD.POST
    },
}